import Big from 'big.js'
import { AnyToken } from '../types/models/Tokens'
import Icon from '../ui-kit/Icon/Icon'
import TokenIcon from '../ui-kit/TokenIcon/TokenIcon'
import { displayAmount } from '../utils/formatters/number'
import clsx from 'clsx'

interface TokenExchangePairProps {
  tokenIn: AnyToken
  tokenOut: AnyToken
  amountIn: Big
  amountOut: Big
  className?: string
}

const TokenExchangePair: React.FC<TokenExchangePairProps> = ({
  tokenIn,
  tokenOut,
  amountIn,
  amountOut,
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex justify-center items-center gap-8 sm:gap-4 font-medium text-main-accent',
        className
      )}
    >
      <div className='flex items-center gap-1 flex-col sm:flex-row'>
        <TokenIcon size={24} token={tokenIn} />
        <span>{displayAmount(amountIn)}</span>
        <span className='typo-label2 text-main-accent'>{tokenIn.symbol}</span>
      </div>
      <div className='p-0.5 bg-primary-muted rounded'>
        <Icon name='arrow-right' color='primary' size={20} />
      </div>
      <div className='flex items-center gap-1 flex-col sm:flex-row'>
        <TokenIcon size={24} token={tokenOut} />
        <span>{displayAmount(amountOut)}</span>
        <span className='typo-label2 text-main-accent'>{tokenOut.symbol}</span>
      </div>
    </div>
  )
}

export default TokenExchangePair
